/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css } from '@emotion/react';
import { MediumText } from '../styles/styles';
import { IAppState } from '../core/redux/IAppState';
import { getApplianceVersionAction } from '../core/getApplianceVersionAction';
import { connect } from 'react-redux';
import { getResource } from '../language/resources/getResource';


const AppVersion = css`
  position: fixed;
  left: 10px;
  bottom: 10px;
  ${MediumText};
  color: #777;
`;


// This global is created by webpack, but we have to declare it or TypeScript gets angry.
declare const __VERSION__: string;

export default connect(
    (state: IAppState) => ({applianceVersion: state.applianceVersion, resources: state.locale}),
    (dispatch) => ({
      getApplianceVersion: () => dispatch(getApplianceVersionAction()),
    })
)(class ResortToolsVersions extends React.PureComponent<{
    applianceVersion?: string,
    resources?: Record<string, any>,
    getApplianceVersion?: () => void,
}> {
    public componentDidMount = () => this.props.getApplianceVersion!();

    public render = () => {
        return (
            <div css={AppVersion}>
                <div title={getResource(this.props.resources, 'CENTRAL_APPLIANCE_VERSION')}>{this.props.applianceVersion ? `v${this.props.applianceVersion}` : ''}</div>
                <div title={getResource(this.props.resources, 'RESORT_TOOLS_VERSION')}>v{__VERSION__}</div>
            </div>
        )
    }
});
